import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";


export const fetchCommunityData = createAsyncThunk(
  "community/fetchCommunityData",
  async ({ page, page_size, search }, { rejectWithValue }) => {
    try {


      // Correct placement of headers and params
      const response = await axiosInstance.get("/auth/provider/", {
        headers: getAuthHeaders(),
        params: { page, page_size, search },
      });

   
      return response.data;
    } catch (error) {
      console.error("Error fetching community data:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchCommunityByCommunityName = createAsyncThunk(
  "community/fetchCommunityDataByName",
  async ({ communityName, city }, { rejectWithValue }) => {
    try {
      // Build the query string dynamically
      const queryParams = new URLSearchParams();

      if (communityName) {
        queryParams.append("community_name", communityName);
      } else {
        console.error("communityName is empty or undefined");
      }

      if (city) {
        queryParams.append("city", city);
      }

      // Log the full query string to debug
      const queryString = queryParams.toString();

      // Make the API request with the query string
      const response = await axiosInstance.get(
        `/community/search/?${queryString}`
      );

      return response.data;
    } catch (error) {
      // Handle errors appropriately
      console.error("API call error:", error.response || error);
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);


//for getting single provider 
export const fetchCommunityByCommunityId = createAsyncThunk(
  "community/fetchCommunityDataById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/provider/${id}/`,
        { headers: getAuthHeaders() }  
      );
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);


export const createNewCommunity = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      // Add the static user_type field to the formData object
      const formDataWithUserType = { ...formData, user_type: "Provider" };

      const response = await axiosInstance.post(
        "/auth/provider/",
        formDataWithUserType,
        { headers: getAuthHeaders() }
      );
      
      

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//for delete a provider 
export const deleteCommunityData = createAsyncThunk(
  "community/deleteCommunityData",
  async (communityId, { rejectWithValue }) => {
    try {

      const response = await axiosInstance.put(
        `/auth/provider/delete/${communityId}`, // Endpoint
        {}, // Data payload (empty in this case for a PUT request)
        { headers: getAuthHeaders() } // Correct placement of headers
      );

    
    
      return response.data;
      
      
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);





export const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
 
  if (!token) {
    throw new Error("Access token is missing. Please log in again.");
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const updateCommunityApi = createAsyncThunk(
  "community/UpdateCommunityApi",
  async ({ formData, id }, { rejectWithValue }) => {

    const token = localStorage.getItem('accessToken');
    

    // Check if token exists
    if (!token) {
      console.error("No token found in localStorage");
      return rejectWithValue("Token missing");
    }

    try {
      const response = await axiosInstance.patch(
        `/auth/provider/${id}`,
        formData,
        { headers: getAuthHeaders() } // Ensure getAuthHeaders() includes the correct token
      );
  
      return response.data;
    } catch (error) {
      // Improved error handling
      console.error("Error occurred", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// export const updateCommunityApi = createAsyncThunk(
//   "community/UpdateCommunityApi",
//   async ({ formData, id }, { rejectWithValue }) => {
//     console.log("Request data", formData, "ID:", id); // Improved logging
//     const token = localStorage.getItem('accessToken');

//     // Check if token exists
//     if (!token) {
//       console.error("No token found in localStorage");
//       return rejectWithValue("Token missing");
//     }

//     try {
//       const response = await axiosInstance.patch(
//         `/auth/provider/${id}`,
//         formData,
//         { headers: getAuthHeaders() } // Ensure getAuthHeaders() includes the correct token
//       );
//       console.log("Response from backend", response);
//       return response.data;
//     } catch (error) {
//       // Improved error handling
//       console.error("Error occurred", error);
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );



export const createNewCommunitydd = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      // Add the static user_type field to the formData object
      const formDataWithUserType = { ...formData, user_type: "Provider" };

      const response = await axiosInstance.post(
        "/auth/provider/",
        formDataWithUserType,
        { headers: getAuthHeaders() }
      );
      
      

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

